import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin: 0px 10px 0px 10px;
  padding-bottom: 20px;
  color: white;
  background: linear-gradient(60deg, rgba(231, 107, 31, 1), rgba(231, 81, 31, 1));
  position: relative;
  top: -15px;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(231, 81, 31, 0.4);
  border-radius: 3px;
`;

const CardHeader = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default CardHeader;
